import { collection, getDocs } from "firebase/firestore/lite";
import db from "../../Components/firebase.config"

// Define and export formatDate
export const formatDate = (dateInput) => {
  if (!dateInput) return "Date not available";
  if (typeof dateInput === "object" && dateInput.seconds !== undefined) {
    // Handle Firebase Timestamp
    const date = new Date(dateInput.seconds * 1000);
    return date.toLocaleString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).replace(/ (\d{4})$/, ", $1"); // e.g., "31 March 2025"
  } else if (typeof dateInput === "string") {
    // Handle string dates
    const parsedDate = new Date(dateInput);
    return isNaN(parsedDate.getTime())
      ? dateInput
      : parsedDate.toLocaleString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).replace(/ (\d{4})$/, ", $1");
  }
  return "Date not available"; // Fallback for unexpected formats
};

const FetchArticles = async () => {
  try {
    const addArticleCollection = collection(db, "GroupAddArticles");
    // const q = query(addArticleCollection, where("category", "==", category));
    const querySnapshot = await getDocs(addArticleCollection);

    const articles = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        route: data.route || doc.id || data.title.toLowerCase().replace(/\s+/g, "-"),
        title: data.title,
        cardImage: data.cardImage || data.img || "/images/default-image.png",
        date: formatDate(data.date), 
        ...data,
      };
    });

    return articles;
  } catch (error) {
    console.error("Error fetching articles:", error);
    return [];
  }
};

export default FetchArticles;